const masteringEN = {
    "view": {
        "table": {
            "title": "Your Mastering List",
            "column": {
                "created_by": "Created By",
                "total_songs": "Number of Songs",
                "mastered_songs": "Total Mastered Songs",
                "created": "Date Created",
                "action": "Action",
            },
            "button": {
                "open": "OPEN",
                "edit": "EDIT",
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
        },
        "message": {
            "noAccess": "You don't have access to this module, please contact the support team for further information.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "noCredits": "You don’t have any audio mastering credits left. Find more about credits <1>here</1> and please reach out to our support team.",
            "learnMore": "Learn all about Audio Mastering <1>here</1>. For more information and <3>credits</3>, please reach out to our support team.",            
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "How many songs do you wish to master?",
                "label": {
                    "number_of_songs": "Number of Songs"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Select no of songs",
                        "song": "Song",
                        "songs": "Songs"
                    }
                },
                "button": {
                    "continue": "Continue"
                }
            },
            "step2": {
                "title": "Select your songs for mastering",
                "button": {
                    "save": "Save"
                }
            },
        },
        "message": {
            "uploadSuccess": "Audio Mastering Songs Uploaded Successfully!",
            "creationSuccess": "Audio Mastering has been created! Now please select your songs in the section below.",
            "error": "An error occurred. Please try again.",
        },
        "modal": {
            "addMastering": {
                "header": "Are you sure you want to add new mastering?",
                "body": "Note: This will result in deduction of {{credits}} credits.",
            },
            "saveMastering": {
                "header": "Are you sure you want to save Audio Mastering?",
                "body": "Note: Please make sure to upload correct audio files as they cannot be modified once saved.",
            },
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Select your songs for mastering",
            },
            "button": {
                "save": "Save"
            }
        },
        "message": {
            "success": "Audio Mastering updated Successfully!",
            "errorCantUpdate": "Audio Mastering can not be updated once the songs are uploaded!",
            "errorMasteringDoesNotExist": "Mastering can not be updated as it does not exist!",
            "error": "An error occurred. Please try again.",
        },
        "modal": {
            "saveMastering": {
                "header": "Are you sure you want to save Audio Mastering?",
                "body": "Note: Please make sure to upload correct audio files as they cannot be modified once saved.",
            },
        }
    },
    "viewSongs": {
        "title": "Audio Mastering Songs",
        "table": {
            "column": {
                "name": "Name",
                "preset": "Preset",
                "intensityAndLoudness": "Intensity & Loudness",
                "preview": "Preview",
                "master": "Master",
                "previewResult": "Preview Result",
                "masteringResult": "Mastering Result",
                "mastered": "Mastered",
                "action": "Action",
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Left",
                "notAvailable": "Not Available"                
            },
            "button": {
                "generate": "Generate",
                "edit": "Edit",
                "exportCsv": "Export CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Acoustic",
                    "allGenres": "All Genres",
                    "classical": "Classical",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Music",
                    "electronic": "Electronic",
                    "electronicRaw": "Electronic Raw",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop Music",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vocal Focused"
                }
            },
            "message": {
                "previewDownloadTooltip": "The preview is being generated. Please allow 5-6 minutes for it to appear.",
                "masteringDownloadTooltip": "Mastering is in process. Please allow 7-15 minutes for it to appear.",
                "alreadyMasteredTooltip": "This song is already mastered."
            }
        },
        "message": {
            "error": "Something went wrong! Please refresh page and try again!",
            "successMaster": "Song sent for Mastering generation!<br/>Note: Please check in few minutes as it takes 7-15 minutes for generating mastering.",
            "successPreview": "Song sent for Mastering Preview generation!<br/>Note: Please check in few minutes as it takes 5-6 minutes for generating mastering preview.",
        },
        "modal": {
            "generateMastering": {
                "header": "Generate Mastering",
                "body": "Are you sure that you want to generate mastering?  This is an irreversible action! The master result shall appear within 7-15 minutes.",
                "message": {
                    "success": "Song sent for Mastering generation!"
                }
            },
            "generateMasteringPreview": {
                "header": "Generate Mastering Preview",
                "body": "Are you sure that you want to generate mastering preview? The preview result shall appear within 5-6 minutes",
                "message": {
                    "success": "Song sent for Mastering Preview generation!"
                }
            },
        }
    },
    "songParametersUpdate": {
        "title": "Edit Song Parameters",
        "form": {
            "label": {
                "intensity": "Intensity",
                "loudness": "Loudness",
                "preset": "Preset"
            },
            "placeholder": {
                "preset": "Select Preset"
            },
            "option": {
                "preset": {
                    "acoustic": "Acoustic",
                    "allGenres": "All Genres",
                    "classical": "Classical",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "EDM Music",
                    "electronic": "Electronic",
                    "electronicRaw": "Electronic Raw",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop Music",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Vocal Focused"
                }
            },
            "button": {
                "submit": "Submit"
            },
            "message": {
                "intensityTooltip": "The ​amount of dynamics, EQ, and processing applied to your song in relation to the overall track and preset selected. Maximum utilization will occur at 100 %. We recommend experimenting with this setting to find the sweet spot which fits you the best.",
                "loudnessTooltip": "The integrated loudness target level. Measured in loudness units relative to full scale (LUFS).​ We recommend experimenting with this setting to find the sweet spot which fits you the best.​ Depending on the style and genre of your song, the best results should appear at -15 up to -9 db",
            }
        },
        "message": {
            "success": "Song parameters have been updated!",
            "error": "Something went wrong! Please refresh page and try again!",
            "songMastered": "Song parameters can not be updated once the song has been mastered!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Songs",
            "name": "Name",
            "genre": "Genre",
            "preset": "Preset",
            "intensity": "Intensity",
            "loudness": "Loudness",
            "audioFile": "Audio File"
        },
        "placeholder": {
            "name": "i.e. Song Name",
            "genre": "i.e. Pop",
            "preset": "Select Preset"
        },
        "option": {
            "preset": {
                "acoustic": "Acoustic",
                "allGenres": "All Genres",
                "classical": "Classical",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "EDM Music",
                "electronic": "Electronic",
                "electronicRaw": "Electronic Raw",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Pop Music",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Vocal Focused"
            }
        },
        "message": {
            "intensityTooltip": "The ​amount of dynamics, EQ, and processing applied to your song in relation to the overall track and preset selected. Maximum utilization will occur at 100 %. We recommend experimenting with this setting to find the sweet spot which fits you the best.",
            "loudnessTooltip": "The integrated loudness target level. Measured in loudness units relative to full scale (LUFS).​ We recommend experimenting with this setting to find the sweet spot which fits you the best.​ Depending on the style and genre of your song, the best results should appear at -15 up to -9 db",
            "audioFileTooltip": "Supported audio formats are : AAC, AIFF, FLAC, MP3, OPUS, VORBIS and WAV.  We strongly recommend using lossless file types such as AIFF, FLAC or WAV. Our mastering tool will always return the same file type as the original file. Bear in mind that you need 16 bit, 44.1 khz WAV file for the distribution.",
            "errorSongNameRequired": "Please enter song name",
            "errorSongNameLength": "Song name should not be more than 80 characters.",
            "errorGenreRequired": "Please enter song genre",
            "errorGenreLength": "Song genre should not be more than 50 characters.",
            "errorPresetRequired": "Preset should be selected.",
            "errorAudioFileRequired": "Please select song file",
            "errorAudioFileValid": "Please upload a valid audio file",            
        }
    },
    "masteringConfirmModal": {
        "header": "Are you sure you want to save Audio Mastering?",
        "body": "Note: Please make sure to upload correct audio files as they cannot be modified once saved.",
        "button": {
            "cancel": "Cancel",
            "confirm": "Confirm"
        },
        "message": {
            "error": "Something went wrong! Please refresh page and try again!"
        }
    }
};
  
  
export default masteringEN;